// Provider ids for the local search sources.
//
// Content search runs the displayed MiniSearch profile under one id and every
// shadow profile under its own (see SHADOW_PROFILES in buildMiniSearchIndices).
// Non-content registries (navigation, external help, quick actions) are served
// by MiniSearch alone. Consumers resolve ids through here rather than
// hard-coding them.

export const PRESENTATION_ENGINES = { MINISEARCH: 'minisearch' }

const LOCAL_PROVIDER_IDS = {
  content: 'minisearch-content',
  navigation: 'navigation-minisearch',
  'external-help': 'external-help-minisearch',
  'quick-actions': 'quick-actions-minisearch',
}

/**
 * Resolve a logical local source (`content`, `navigation`, `external-help`,
 * `quick-actions`) to its provider id. Returns the base unchanged for an
 * unknown source.
 *
 * The second argument is accepted for callers that still pass the presentation
 * engine; there is only one.
 *
 * @param {string} base
 * @returns {string}
 */
export function localProviderId(base) {
  return LOCAL_PROVIDER_IDS[base] || base
}

/**
 * Provider id of the shadow content provider running `profile`.
 *
 * @param {string} profile a key of PROFILES
 * @returns {string}
 */
export function shadowProviderId(profile) {
  return `minisearch-shadow-${profile}`
}
